import PropTypes from 'prop-types';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { PERMISSIONS, hasOrganizationPermission } from 'utils/organizationPermissions';
import { isMessagingEnabled } from 'utils/messagingAccess';

const FEATURE_PERMISSIONS = {
  subscriptionRetention: [PERMISSIONS.NAV_CHARTS, PERMISSIONS.FEATURE_SUBSCRIPTION_RETENTION],
  ltvChart: [PERMISSIONS.NAV_CHARTS, PERMISSIONS.FEATURE_LTV],
  mailingNotifications: [PERMISSIONS.NAV_MAILING],
};

const FeatureGuard = ({ children, feature }) => {
  const { user } = useAuth();
  const { appId } = useParams();
  const required = feature ? FEATURE_PERMISSIONS[feature] : null;

  if (required && !hasOrganizationPermission(user?.organizationRole, required)) {
    return <Navigate to='/403' replace />;
  }
  // Messaging is switched on per application, not only per role.
  if (feature === 'mailingNotifications' && !isMessagingEnabled(appId)) {
    return <Navigate to='/403' replace />;
  }

  return children || <Outlet />;
};

FeatureGuard.propTypes = {
  children: PropTypes.node,
  feature: PropTypes.string,
};

export default FeatureGuard;
